enum ProductMediaDisplay {
  Landscape,
  Square,
}

export default ProductMediaDisplay;
